module.exports = __webpack_public_path__ + "static/img/about_list2.56f10d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about_list2.png
// module id = +QlY
// module chunks = 1